import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import 'moment/locale/fr'
import 'moment/locale/zh-cn'

const localeMap = {
  en: 'en',
  fr: 'fr',
  zh: 'zh-cn'
}

function useMomentLocale() {
  const { i18n } = useTranslation()
  const [lang, setLang] = useState(i18n.lang)
  const updateLang = useCallback(lang => setLang(lang), [setLang])
  useEffect(() => {
    i18n.on('languageChanged', updateLang)
    return () => {
      i18n.off('languageChanged', updateLang)
    }
  }, [updateLang, i18n])
  return localeMap[lang] || null
}

export default useMomentLocale
